import { useMediaQuery } from '@mui/material';
import AppMobileXS from './AppMobileXS';
import AppMobile from './AppMobile';
import AppDesktop from './AppDesktop';
import "./AppDesktop.css"
import "./AppMobile.css"
import "./AppMobileXS.css"

function App() {
  const isDesktop = useMediaQuery('(min-width:1200px)');
  const isTablet = useMediaQuery('(min-width:800px)');
  const isMobile = useMediaQuery('(max-width:600px)');

  //return ( <AppMobileXS />)
  return (
    isDesktop ? <AppDesktop /> :
    isTablet ? <AppMobile /> :
    <AppMobileXS/>
    
  );
}

export default App;
